// @ts-nocheck

import React, { useEffect, useState } from 'react';
import 'react-image-crop/dist/ReactCrop.css';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { RootState } from '../../../app/store';
import { Link, useNavigate, useParams } from 'react-router-dom';

interface BaseDetailsProps {
  userDetails: UserDetails;
}

const ViewDepartment: React.FC<BaseDetailsProps> = React.memo(({ userDetails }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [logoUrl, setLogoUrl] = useState<string>('');
  const [logoUrlCover, setLogoUrlCover] = useState<string>('');
  const [logoLoading, setLogoLoading] = useState(true);
  const [coverLoading, setCoverLoading] = useState(true);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { departmentId } = useParams<{ departmentId: any }>();
  const baseIdString = localStorage.getItem('UserBaseId') || localStorage.getItem('createBaseId');
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  useEffect(() => {
    const baseInfoString = localStorage.getItem('baseDepartmentData');

    if (baseInfoString) {
      try {
        const baseInfo = JSON.parse(baseInfoString);
        const department = baseInfo.data.find((dept: any) => dept.id === departmentId);

        if (department) {
          setName(department.department_name);
          setDescription(department.department_description);

          if (department.department_image) {
            setLogoUrl(`${process.env.REACT_APP_API_BASE_URL}/${department.department_image}`);
          }

          if (department.department_cover_image) {
            setLogoUrlCover(`${process.env.REACT_APP_API_BASE_URL}/${department.department_cover_image}`);
          }
        } else {
          console.error(`Department with ID ${departmentId} not found.`);
        }
      } catch (error) {
        console.error("Failed to parse baseDepartmentData:", error);
      }
    }
  }, [departmentId]);

  const handleEdit = () => {
    navigate(`/${baseId}/settings/department/${departmentId}/edit`);
  };

  return (
    <div className='w-full max-w-[640px] m-auto'>
      <main className='h-full flex mt-10'>
        <div className='w-full flex justify-center'>
          <div className='w-full '>
            <Link to={`/${baseId}/settings/department`}
              className=' flex items-center gap-x-1 w-full mb-5'
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 6l-6 6l6 6" />
              </svg>
              <span className='text-black-100 text-[13px]'>
                Back to Department
              </span>
              {/* <ArrowLeftIcon /> */}
            </Link>
            <div className='flex flex-col gap-y-[6px]'>
              <h2 className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]'>
                Department
              </h2>
              <p className='text-sm leading-6 text-[#5c5c5e] font-medium'>
                This information will be displayed publicly so be careful what you share.
              </p>
            </div>
            <div className='mt-12 flex items-center justify-end'>
              <button
                onClick={handleEdit}
                type='submit'
                className='group inline-flex shrink-0  select-none justify-center items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 transition-colors
                duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0
                  rounded-md text-white outline-indigo-600
                disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'
              >
                Edit
              </button>
            </div>
            <div className='bg-[#e0e0e0] w-full h-[1px] my-6'></div>
            <div className="h-auto relative">
              {logoUrlCover && (
                <img
                  src={logoUrlCover}
                  alt="Department Cover"
                  className="w-full border border-[#e0e0e0] border-solid rounded-lg object-cover cursor-move h-[150px]"
                  onLoad={() => setCoverLoading(false)}
                />
              )}
              {logoUrl && (
                <div className="absolute top-[118px] left-[36px] h-[70px] w-[70px]">

                  <img
                    src={logoUrl}
                    alt="Department Logo"
                    className="h-full w-full border-[5px] border-solid border-[#f5f5f5] rounded-2xl object-cover cursor-move"
                    onLoad={() => setLogoLoading(false)}
                  />

                </div>
              )}
            </div>
            <div className='sm:col-span-4 mt-14 lg:mt-16'>
              <div className='mt-[6px]'>
                <p className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]'> {name}</p>
              </div>
            </div>
            <div className='sm:col-span-4 mt-5'>
              <div className='mt-[6px]'>
                <p className='text-sm leading-6 text-[#5c5c5e] font-medium'>{description}</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
});

export default ViewDepartment;
